<template>
  <div class="progress-page">
    <div class="hero-card">
      <div>
        <div class="hero-title">项目完成度看板</div>
        <div class="hero-desc">默认只展开一级节点。只有第一级自动统计，二级及以下都支持手动填写，综合完成度始终自动计算。</div>
      </div>
      <div class="hero-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openAdd()">添加一级</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="loadData">刷新数据</el-button>
        <el-button @click="expandFirstLevel">只看一级</el-button>
        <el-button @click="collapseAll">全部收起</el-button>
      </div>
    </div>

    <div class="summary-row">
      <div class="summary-card blue">
        <div class="summary-label">总节点</div>
        <div class="summary-value">{{ summary.total }}</div>
      </div>
      <div class="summary-card green">
        <div class="summary-label">叶子节点</div>
        <div class="summary-value">{{ summary.leaf_total }}</div>
      </div>
      
    </div>

    <div class="table-card">
      <el-table
        :key="tableKey"
        :data="tableData"
        row-key="id"
        border
        :expand-row-keys="expandedRowKeys"
        :tree-props="{ children: 'children' }"
        :indent="28"
        :row-class-name="getRowClassName"
        style="width: 100%;"
      >
        <el-table-column label="图片 / 名称" min-width="300">
          <template slot-scope="scope">
            <div class="name-cell">
              <div class="level-tag">L{{ scope.row.level }}</div>
              <img v-if="scope.row.img" :src="scope.row.img" class="thumb" />
              <div v-else class="thumb thumb-empty">{{ getNameFirst(scope.row.name) }}</div>
              <div class="name-meta">
                <div class="main-name-row">
                  <div class="main-name clickable-name" @click="openImgEdit(scope.row)">
                    <span v-if="scope.row.parent_name_path" class="path-prefix">{{ scope.row.parent_name_path }} / </span>
                    <span class="current-name">{{ scope.row.name || '未命名' }}</span>
                  </div>
                  <span class="name-id">ID {{ scope.row.id }}</span>
                </div>
                <div class="sub-line">
                  <span>层级：{{ scope.row.level }}</span>
                  <span>{{ scope.row.level === 1 ? '一级自动统计' : '手动填写' }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="ui_progress" label="UI" width="220">
          <template slot-scope="scope">
            <div class="progress-col progress-clickable" :class="{ disabled: !scope.row.can_edit_progress }" @click="openProgressEdit(scope.row)">
              <el-progress :percentage="toPercent(scope.row.ui_progress)" :stroke-width="14" :format="formatProgressText"></el-progress>
              <span v-if="scope.row.can_edit_progress" class="progress-edit-text">点击填写</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="backend_progress" label="后端" width="220">
          <template slot-scope="scope">
            <div class="progress-col progress-clickable" :class="{ disabled: !scope.row.can_edit_progress }" @click="openProgressEdit(scope.row)">
              <el-progress :percentage="toPercent(scope.row.backend_progress)" color="#36c275" :stroke-width="14" :format="formatProgressText"></el-progress>
              <span v-if="scope.row.can_edit_progress" class="progress-edit-text">点击填写</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="android_progress" label="安卓" width="220">
          <template slot-scope="scope">
            <div class="progress-col progress-clickable" :class="{ disabled: !scope.row.can_edit_progress }" @click="openProgressEdit(scope.row)">
              <el-progress :percentage="toPercent(scope.row.android_progress)" color="#9b6bff" :stroke-width="14" :format="formatProgressText"></el-progress>
              <span v-if="scope.row.can_edit_progress" class="progress-edit-text">点击填写</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="综合完成度" width="160">
          <template slot-scope="scope">
            <div class="avg-box">{{ formatAvg(scope.row.avg_progress) }}%</div>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.can_edit_progress" size="mini" type="warning">手动填写</el-tag>
            <el-tag v-else size="mini" type="success">自动统计</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <div class="action-group">
              <el-button
                v-if="scope.row.can_edit_progress"
                type="text"
                @click="openProgressEdit(scope.row)"
              >
                修改完成度
              </el-button>
              <span v-else class="auto-text">自动汇总</span>
              <el-button
                type="text"
                @click="openAdd(scope.row)"
              >
                添加下一级
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="添加功能"
      :visible.sync="addDialogVisible"
      width="620px"
    >
      <div class="dialog-name">{{ currentAddRow.name ? ('上级：' + currentAddRow.name) : '添加一级分类' }}</div>
      <el-form label-width="90px">
        <el-form-item label="功能名称">
          <el-input
            v-model="addForm.name"
            placeholder="请输入功能名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片地址">
          <el-input
            v-model="addForm.img"
            type="textarea"
            :rows="3"
            placeholder="请输入图片地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addSubmitLoading" @click="submitAdd">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改图片地址"
      :visible.sync="imgDialogVisible"
      width="620px"
    >
      <div class="dialog-name">{{ currentImgRow.name || '未命名' }}</div>
      <el-form label-width="90px">
        <el-form-item label="图片地址">
          <el-input
            v-model="imgForm.img"
            type="textarea"
            :rows="4"
            placeholder="请输入图片地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="imgDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="imgSubmitLoading" @click="submitImgEdit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改完成度"
      :visible.sync="dialogVisible"
      width="560px"
    >
      <div class="dialog-name">{{ currentRow.name || '未命名' }}</div>

      <div class="edit-item">
        <div class="edit-label">UI 完成度</div>
        <div class="edit-control">
          <el-input-number v-model="form.ui_progress" :min="0" :max="100" :step="1" controls-position="right"></el-input-number>
          <span class="edit-unit">%</span>
        </div>
      </div>

      <div class="edit-item">
        <div class="edit-label">后端完成度</div>
        <div class="edit-control">
          <el-input-number v-model="form.backend_progress" :min="0" :max="100" :step="1" controls-position="right"></el-input-number>
          <span class="edit-unit">%</span>
        </div>
      </div>

      <div class="edit-item">
        <div class="edit-label">安卓完成度</div>
        <div class="edit-control">
          <el-input-number v-model="form.android_progress" :min="0" :max="100" :step="1" controls-position="right"></el-input-number>
          <span class="edit-unit">%</span>
        </div>
      </div>

      <div class="edit-tip">
        只有第一级自动统计。当前项保存后，会按全部下级项目的总值重新计算第一级完成度。
      </div>

      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      apiBase: 'https://tossp.yoooooo.com/index.php/index/tongji',
      tableData: [],
      tableKey: 1,
      expandedRowKeys: [],
      addDialogVisible: false,
      imgDialogVisible: false,
      dialogVisible: false,
      addSubmitLoading: false,
      imgSubmitLoading: false,
      submitLoading: false,
      currentAddRow: {},
      currentImgRow: {},
      currentRow: {},
      addForm: {
        parent_id: 0,
        name: '',
        img: ''
      },
      imgForm: {
        id: 0,
        img: ''
      },
      form: {
        id: 0,
        ui_progress: 0,
        backend_progress: 0,
        android_progress: 0
      },
      summary: {
        total: 0,
        leaf_total: 0,
        ui_avg: 0,
        backend_avg: 0,
        android_avg: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData(customExpandedRowKeys) {
      try {
        const res = await axios.post(this.apiBase + '/getStatisticsProgressTree')
        this.tableData = this.appendNamePath(res.data.data || [])
        this.summary = res.data.summary || this.summary
        this.expandedRowKeys = Array.isArray(customExpandedRowKeys) && customExpandedRowKeys.length
          ? customExpandedRowKeys
          : this.getFirstLevelKeys(this.tableData)
      } catch (e) {
        this.$message.error('加载失败')
      }
    },
    expandFirstLevel() {
      this.expandedRowKeys = this.getFirstLevelKeys(this.tableData)
      this.tableKey += 1
    },
    collapseAll() {
      this.expandedRowKeys = []
      this.tableKey += 1
    },
    openAdd(row) {
      var parentRow = row || {}
      this.currentAddRow = parentRow
      this.addForm = {
        parent_id: parentRow.id || 0,
        name: '',
        img: ''
      }
      this.addDialogVisible = true
    },
    async submitAdd() {
      if (!this.addForm.name) {
        this.$message.error('请输入功能名称')
        return
      }
      this.addSubmitLoading = true
      try {
        const res = await axios.post(this.apiBase + '/addStatistics', this.addForm)
        if (res.data.code === 200) {
          this.$message.success('添加成功')
          this.addDialogVisible = false
          this.loadData(this.getExpandKeysAfterAdd())
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.addSubmitLoading = false
    },
    openImgEdit(row) {
      this.currentImgRow = row
      this.imgForm = {
        id: row.id,
        img: row.img || ''
      }
      this.imgDialogVisible = true
    },
    async submitImgEdit() {
      this.imgSubmitLoading = true
      try {
        const res = await axios.post(this.apiBase + '/updateStatisticsInfo', this.imgForm)
        if (res.data.code === 200) {
          this.$message.success('图片地址已更新')
          this.imgDialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.imgSubmitLoading = false
    },
    openProgressEdit(row) {
      if (!row.can_edit_progress) {
        return
      }
      this.currentRow = row
      this.form = {
        id: row.id,
        ui_progress: this.toNumber(row.ui_progress),
        backend_progress: this.toNumber(row.backend_progress),
        android_progress: this.toNumber(row.android_progress)
      }
      this.dialogVisible = true
    },
    async submitEdit() {
      this.submitLoading = true
      try {
        const res = await axios.post(this.apiBase + '/updateStatisticsProgress', this.form)
        if (res.data.code === 200) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.submitLoading = false
    },
    toNumber(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return 0
      }
      if (num < 0) {
        return 0
      }
      if (num > 100) {
        return 100
      }
      return Math.round(num)
    },
    toPercent(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return 0
      }
      if (num < 0) {
        return 0
      }
      if (num > 100) {
        return 100
      }
      return Number(num.toFixed(2))
    },
    formatAvg(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    formatProgressText(percentage) {
      var num = Number(percentage)
      if (isNaN(num)) {
        return '0%'
      }
      return num.toFixed(2).replace(/\.00$/, '') + '%'
    },
    getNameFirst(name) {
      if (!name) {
        return '图'
      }
      return String(name).slice(0, 1)
    },
    getFirstLevelKeys(list) {
      var keys = []
      ;(list || []).forEach(function(item) {
        keys.push(item.id)
      })
      return keys
    },
    getExpandKeysAfterAdd() {
      var parentIdPath = this.currentAddRow.parent_id_path || []
      var currentId = this.currentAddRow.id
      var keys = parentIdPath.slice()
      if (currentId) {
        keys.push(currentId)
      }
      if (!keys.length) {
        return this.getFirstLevelKeys(this.tableData)
      }
      return keys
    },
    appendNamePath(list, parents, parentIds) {
      var parentNames = parents || []
      var parentIdPath = parentIds || []
      return (list || []).map(function(item) {
        var currentName = item.name || '未命名'
        var row = Object.assign({}, item)
        row.parent_name_path = parentNames.join(' / ')
        row.parent_id_path = parentIdPath.slice()
        row.children = this.appendNamePath(item.children || [], parentNames.concat(currentName), parentIdPath.concat(row.id))
        return row
      }, this)
    },
    getRowClassName(obj) {
      return 'level-row-' + (obj.row.level || 1)
    }
  }
}
</script>

<style scoped>
.progress-page {
  min-height: 100vh;
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 24px;
  box-sizing: border-box;
  float: none !important;
  position: relative;
  left: 0;
  right: auto;
  transform: none !important;
  background: #f4f7fb;
  overflow-x: auto;
}

.progress-page,
.progress-page * {
  box-sizing: border-box;
}

.hero-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  margin-bottom: 20px;
  border-radius: 18px;
  background: linear-gradient(135deg, #3f7cff 0%, #7f63ff 100%);
  color: #fff;
  box-shadow: 0 14px 34px rgba(84, 102, 255, 0.2);
}

.hero-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.hero-desc {
  font-size: 14px;
  opacity: 0.9;
}

.hero-actions .el-button + .el-button {
  margin-left: 12px;
}

.summary-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px 20px;
}

.summary-card {
  width: calc(25% - 16px);
  min-width: 220px;
  margin: 0 8px 16px;
  padding: 20px 22px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.summary-card.blue {
  border-top: 4px solid #3f7cff;
}

.summary-card.green {
  border-top: 4px solid #36c275;
}

.summary-card.purple {
  border-top: 4px solid #7f63ff;
}

.summary-card.orange {
  border-top: 4px solid #ff9f43;
}

.summary-label {
  color: #8a94a6;
  font-size: 14px;
}

.summary-value {
  margin-top: 10px;
  color: #1f2d3d;
  font-size: 28px;
  font-weight: 700;
}

.table-card {
  width: 100%;
  padding: 18px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.06);
  overflow: hidden;
}

.table-card /deep/ .el-table {
  width: 100% !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.table-card /deep/ .el-table__fixed,
.table-card /deep/ .el-table__fixed-right,
.table-card /deep/ .el-table__fixed-body-wrapper,
.table-card /deep/ .el-table__body-wrapper,
.table-card /deep/ .el-table__header-wrapper {
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.table-card /deep/ .el-table__row td {
  transition: background-color 0.2s ease;
}

.table-card /deep/ .level-row-1 td {
  background: #f6f9ff;
}

.table-card /deep/ .level-row-2 td {
  background: #fbfcff;
}

.table-card /deep/ .level-row-3 td {
  background: #fffdf8;
}

.table-card /deep/ .level-row-4 td,
.table-card /deep/ .level-row-5 td,
.table-card /deep/ .level-row-6 td {
  background: #fff;
}

.table-card /deep/ .level-row-1 .el-table__indent {
  border-left: 4px solid #4f67ff;
}

.table-card /deep/ .level-row-2 .el-table__indent {
  border-left: 4px solid #7f63ff;
}

.table-card /deep/ .level-row-3 .el-table__indent {
  border-left: 4px solid #ff9f43;
}

.name-cell {
  display: flex;
  align-items: center;
}

.level-tag {
  min-width: 42px;
  height: 28px;
  line-height: 28px;
  margin-right: 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, #eff3ff 0%, #dde7ff 100%);
  color: #4f67ff;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  flex-shrink: 0;
}

.thumb {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  object-fit: cover;
  background: #eef2ff;
  flex-shrink: 0;
}

.thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4f67ff;
  font-size: 20px;
  font-weight: 600;
}

.name-meta {
  margin-left: 14px;
  min-width: 0;
}

.main-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.main-name {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-all;
}

.path-prefix {
  color: #7d8ba3;
  font-weight: 500;
}

.current-name {
  color: #1f2d3d;
  font-weight: 700;
}

.name-id {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid #d6e4ff;
  background: #edf4ff;
  color: #245bdb;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.clickable-name {
  display: inline-block;
  cursor: pointer;
  transition: all 0.2s ease;
}

.clickable-name:hover {
  color: #4f67ff;
  text-decoration: underline;
}

.sub-line {
  margin-top: 6px;
  color: #8a94a6;
  font-size: 12px;
}

.sub-line span {
  margin-right: 14px;
}

.progress-col {
  padding-right: 8px;
}

.progress-clickable {
  cursor: pointer;
}

.progress-clickable.disabled {
  cursor: default;
}

.progress-edit-text {
  display: inline-block;
  margin-top: 6px;
  color: #4f67ff;
  font-size: 12px;
}

.avg-box {
  color: #4f67ff;
  font-weight: 600;
}

.action-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.4;
}

.action-group .el-button + .el-button {
  margin-left: 0;
  margin-top: 2px;
}

.auto-text {
  color: #8a94a6;
}

.dialog-name {
  margin-bottom: 20px;
  color: #1f2d3d;
  font-size: 16px;
  font-weight: 600;
}

.edit-item {
  margin-bottom: 18px;
}

.edit-label {
  margin-bottom: 10px;
  color: #52627a;
  font-size: 14px;
}

.edit-control {
  display: flex;
  align-items: center;
}

.edit-unit {
  margin-left: 10px;
  color: #6b778c;
  font-size: 14px;
}

.edit-tip {
  padding: 12px 14px;
  border-radius: 10px;
  background: #f5f8ff;
  color: #6b778c;
  font-size: 13px;
}

@media screen and (max-width: 1200px) {
  .summary-card {
    width: calc(50% - 16px);
  }
}

@media screen and (max-width: 768px) {
  .progress-page {
    padding: 16px;
  }

  .hero-card {
    display: block;
  }

  .hero-actions {
    margin-top: 16px;
  }

  .summary-card {
    width: calc(100% - 16px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/aatongjiProgress.vue